export enum InputType {
  Password = 'password',
  Text = 'text',
  Date = 'date',
  Email = 'email',
  File = 'file',
  Number = 'number',
  Tel = 'tel',
}
